import request from '@/utils/request'

function getNews(offset, length) {
    return request({
        url: `/api/news/published?offset=${offset}&length=${length}`,
        method: 'get'
    })
}

function getNewsContent(id) {
    return request({
        url: `/api/news/${id}`,
        method: 'get'
    })
}

export { getNews, getNewsContent }


// WEBPACK FOOTER //
// ./src/api/api_news.js